import React from "react";

export const CREATIVE_PHASES = [
  { key: "echanges_preparation", label: "Échanges & préparation" },
  { key: "creation", label: "Création" },
  { key: "proposition", label: "Proposition" },
  { key: "ajustements", label: "Ajustements" },
  { key: "validation", label: "Validation" },
  { key: "livraison", label: "Livraison" },
];

export const CREATIVE_PHASE_LABELS = Object.fromEntries(
  CREATIVE_PHASES.map((p) => [p.key, p.label])
);

export default function CreativePhaseTimeline({ currentPhase }) {
  const activeIdx = Math.max(
    0,
    CREATIVE_PHASES.findIndex((p) => p.key === currentPhase)
  );
  return (
    <div className="cs-card p-6" data-testid="creative-phase-timeline">
      <div className="cs-eyebrow text-[#0E7C90]">Progression créative</div>

      {/* Desktop : ligne horizontale */}
      <ol className="mt-6 hidden md:grid grid-cols-6 gap-2 relative">
        {CREATIVE_PHASES.map((phase, i) => {
          const done = i < activeIdx;
          const active = i === activeIdx;
          return (
            <li
              key={phase.key}
              className="relative flex flex-col items-start"
              data-testid={`creative-phase-step-${phase.key}`}
              data-active={active ? "true" : "false"}
            >
              {i < CREATIVE_PHASES.length - 1 && (
                <span
                  aria-hidden
                  className={`absolute top-[10px] left-[22px] right-0 h-[2px] ${
                    done ? "bg-[#0E7C90]" : "bg-black/10"
                  }`}
                />
              )}
              <span
                className={`relative z-10 w-5 h-5 rounded-full border-2 flex-shrink-0 ${
                  active
                    ? "bg-[#0E7C90] border-[#0E7C90] ring-4 ring-[#0E7C90]/15"
                    : done
                    ? "bg-[#0E7C90] border-[#0E7C90]"
                    : "bg-white border-black/25"
                }`}
              />
              <span
                className={`mt-3 text-[11px] font-mono uppercase tracking-[0.14em] ${
                  active
                    ? "text-[#0E7C90]"
                    : done
                    ? "text-neutral-700"
                    : "text-neutral-400"
                }`}
              >
                {phase.label}
              </span>
            </li>
          );
        })}
      </ol>

      {/* Mobile : liste verticale */}
      <ol className="mt-6 md:hidden space-y-3">
        {CREATIVE_PHASES.map((phase, i) => {
          const done = i < activeIdx;
          const active = i === activeIdx;
          return (
            <li
              key={phase.key}
              className="flex items-center gap-3"
              data-testid={`creative-phase-step-mobile-${phase.key}`}
              data-active={active ? "true" : "false"}
            >
              <span
                className={`w-4 h-4 rounded-full border-2 flex-shrink-0 ${
                  active
                    ? "bg-[#0E7C90] border-[#0E7C90] ring-4 ring-[#0E7C90]/15"
                    : done
                    ? "bg-[#0E7C90] border-[#0E7C90]"
                    : "bg-white border-black/25"
                }`}
              />
              <span
                className={`text-sm ${
                  active
                    ? "text-[#0E7C90] font-medium"
                    : done
                    ? "text-neutral-700"
                    : "text-neutral-400"
                }`}
              >
                {phase.label}
              </span>
            </li>
          );
        })}
      </ol>

      <p className="mt-6 text-sm leading-relaxed text-neutral-700">
        Cet espace est fait pour construire votre projet ensemble. Vous pouvez
        partager librement vos idées, références, fichiers et questions tout au
        long de la création.
      </p>
      <p className="mt-3 text-[13px] leading-relaxed text-neutral-500 italic">
        Les échanges et discussions sont libres. Les séries d’ajustements
        incluses dans votre prestation concernent uniquement les modifications
        demandées après présentation d’une création.
      </p>
    </div>
  );
}
